import "../styles/auth.css"; // Import styles
import logo from "../images/icons/header-logo.svg";
import loginSideImage from "../images/login_page/login_image.svg";
import calendarImage from "../images/calendar_month.svg";
import eyeImage from "../images/login_page/eye-image.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  resetPassword,
  userForgotPassword,
  userVarifyToken,
} from "../actions/usersActions";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

// Functional component for the Home page
const ResetPassword = () => {
  const dispatch = useDispatch();
  const { usersForgotPassword, loading, error } = useSelector(
    (state) => state.users
  );
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const [isVerified, setIsVerified] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const passwordSchema = Yup.object().shape({
    otp: Yup.string().required("OTP is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .max(15, "Password must be at most 15 characters long")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });
  const handleSubmit = async () => {
    try {
      const res = await dispatch(userVarifyToken({ token }));
      if (res.data.code == 200) {
        toast.success(res.data?.message);
        setIsVerified(true)
      } else {
        toast.error(res.data?.message);
      }
    } catch (error) {
    }
  };

  const resetPasswrodSubmit = async (values, { setSubmitting }) => {
    try {
      const result = await dispatch(
        resetPassword({
          token,
          otp: values.otp,
          newPassword: values.password,
        })
      );
      setSubmitting(false);
      if (result.data.code == 200) {
        toast.success(result.data?.message);
        navigate("/login");
      }
    } catch (error) {
    }
  };
  return (
    <section className="login" id="auth_section">
      <div className="container-fluid  login-container">
        <div className="row">
          <div className="col-lg-6 col-md-5 px-0">
            <div className="auth_left_content d-md-flex d-none card h-100 justify-content-start">
              <Link className="navbar-brand" to={`/`}>
                <img src={logo} alt="Logo" />
                {/* Replace 'logo.png' with your logo image path */}
                FUNDSWALA
              </Link>
              <div className="mb-xxl-5">
                <h3 className="geeting_text mb-lg-4">Welcome to Fundswala</h3>
                <h3 className="mb-4">Join Us Now ! </h3>
              </div>
              <img src={loginSideImage} alt="" className="login-image " />
            </div>
          </div>
          <div className="col-lg-6  col-md-7 px-0">
            <div className="right-side-container" style={{ height: "100vh" }}>
              <div className="d-md-none d-flex flex-column align-items-center">
                <Link
                  className="navbar-brand"
                  to={`/`}
                  style={{ color: "var(--primary-color)" }}
                >
                  <img src={logo} alt="Logo" />
                  {/* Replace 'logo.png' with your logo image path */}
                  FUNDSWALA
                </Link>
                <div className="my-3 text-center">
                  <h3
                    className="geeting_text "
                    style={{ color: "var(--primary-color)" }}
                  >
                    Welcome to Fundswala
                  </h3>
                  <h3
                    className="geeting_text mb-0"
                    style={{ color: "var(--primary-color)" }}
                  >
                    Join Us Now !{" "}
                  </h3>
                </div>
                {/* <a href="/" className="back-link  d-block d-md-none mb-3 mt-3">
                  <FontAwesomeIcon
                    icon={faAngleLeft}
                    className="color me-2"
                    style={{ fontSize: "16px" }}
                  />
                  Back
                </a> */}
                <h5 className="form-title d-md-none d-block my-0" style={{}}>
                  Reset Password?
                </h5>
              </div>

              {/* <!-- Tab Content --> */}
              <div className="tab-content mt-md-3 mt-4">
                <div
                  className="tab-pane fade show active"
                  id="signIn"
                  role="tabpanel"
                  aria-labelledby="signin-tab"
                >
                  {/* <a href="/" className="back-link d-md-block d-none">
                    <FontAwesomeIcon
                      icon={faAngleLeft}
                      className="color me-2"
                      style={{ fontSize: "16px" }}
                    />
                    Back
                  </a> */}
                  <h5 className="form-title d-md-block d-none">
                    Reset Password?
                  </h5>
                  <Formik
                    initialValues={{ email: "" }}
                    validationSchema={passwordSchema}
                    onSubmit={resetPasswrodSubmit}
                  >
                    {({ isSubmitting }) => (
                      <Form>
                        {/* <div className="form-group">
                          <label htmlFor="email" className="form-label">
                            Email
                          </label>
                          <Field
                            type="text"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="Enter Your Email"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="error-message text-danger mt-1"
                          />
                        </div> */}
                        {isVerified && (
                          <>
                            <div className="form-group">
                              <label>OTP</label>
                              <Field
                                type="text"
                                name="otp"
                                placeholder="Enter OTP"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="otp"
                                component="div"
                                className="text-danger"
                              />
                            </div>

                            {/* <div className="form-group">
                              <label>New Password</label>
                              <Field
                                type="password"
                                name="password"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="password"
                                component="div"
                                className="text-danger"
                              />
                            </div> */}

                                            <div>
                                              <label>New Password</label>
                                            </div>
                                                     
                                                      <div className=" position-relative">
                                                        
                                                        <div
                                                          style={{
                                                            position: "relative",
                                                          }}
                                                        >
                                                          <Field
                                                            type={showNewPassword ? "text" : "password"}
                                                            className="form-control"
                                                            id="password"
                                                            name="password"
                                                            placeholder="Enter New Password"
                                                          />
                                                          <span
                                                            className="position-absolute"
                                                            onClick={() =>
                                                              setShowNewPassword(!showNewPassword)
                                                            }
                                                            style={{
                                                              right: "10px",
                                                              top: "50%",
                                                              transform: "translateY(-50%)",
                                                              cursor: "pointer",
                                                            }}
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={!showNewPassword ? faEyeSlash : faEye}
                                                            />
                                                          </span>
                                                        </div>
                                                        <div>
                                                          <ErrorMessage
                                                            name="password"
                                                            component="div"
                                                            className="text-danger"
                                                          />
                                                        </div>
                                                      </div>

                            {/* <div className="form-group">
                              <label>Confirm Password</label>
                              <Field
                                type="password"
                                name="confirmPassword"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="confirmPassword"
                                component="div"
                                className="text-danger"
                              />
                            </div> */}

                              
                                                    <div className="mt-4">
                                              <label>Confirm Password</label>
                                            </div>
                                                      <div className="position-relative">
                                                        <div
                                                          style={{
                                                            position: "relative",
                                                          }}
                                                        >
                                                          <Field
                                                            type={showConfirmPassword ? "text" : "password"}
                                                            className="form-control"
                                                            id="confirmPassword"
                                                            name="confirmPassword"
                                                            placeholder="Enter Confirm Password"
                                                          />
                                                          <span
                                                            className="position-absolute"
                                                            onClick={() =>
                                                              setShowConfirmPassword(!showConfirmPassword)
                                                            }
                                                            style={{
                                                              right: "10px",
                                                              top: "50%",
                                                              transform: "translateY(-50%)",
                                                              cursor: "pointer",
                                                            }}
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={
                                                                !showConfirmPassword ? faEyeSlash : faEye
                                                              }
                                                            />
                                                          </span>
                                                        </div>
                                                        <div>
                                                          <ErrorMessage
                                                            name="confirmPassword"
                                                            component="div"
                                                            className="text-danger"
                                                          />
                                                        </div>
                                                      </div>
                                                    
                          </>
                        )}

                        {!isVerified && (
                          <div className="mt-md-5 mt-sm-4 mt-3 text-end">
                            <button
                              type="submit"
                              className="form_button next_btn"
                              disabled={isSubmitting}
                              onClick={handleSubmit}
                            >
                              {"Verify reset token"}
                            </button>
                          </div>
                        )}

                        {isVerified && (
                          <div className="mt-md-5 mt-sm-4 mt-3 text-end">
                            <button
                              type="submit"
                              className="form_button next_btn"
                              disabled={isSubmitting}
                            >
                              {"Reset password"}
                            </button>
                          </div>
                        )}
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
